import { BrowserRouter, Route, Routes } from "react-router-dom";

import Sidebar from "components/Sidebar";
import { AuthProvider } from "context/AuthContext";
import { ToastContextProvider } from "context/ToastContext";
import ForgotPassword from "Pages/auth/ForgotPassword";
import Login from "Pages/auth/Login";
import LoginFromSmartfin from "Pages/auth/LoginIntegration/LoginFromSmartfin";
import LoginWithSmartfinCallback from "Pages/auth/LoginIntegration/LoginWithSmartfinCallback";
import LoginOtp from "Pages/auth/LoginOtp";
import OtpScreen from "Pages/auth/OtpScreen";
import RegisterOtp from "Pages/auth/RegisterOtp";
import AddMoney from "Pages/Dashboard/AddMoney/AddMoney";
import MyCards from "Pages/Dashboard/AddMoney/MyCards/MyCards";
import TransactionDetailsMobile from "Pages/Dashboard/TransactionDetailsMobile";
import GiftCards from "Pages/Dashboard/TransferMoney/GiftCards/GiftCards";
import GiftCardsHistory from "Pages/Dashboard/TransferMoney/GiftCards/GiftCardsHistory";
import TransferMoney from "Pages/Dashboard/TransferMoney/TransferMoney";
import TransferUsername from "Pages/Dashboard/TransferMoney/TransferUsername";
import TransferWallets from "Pages/Dashboard/TransferMoney/TransferWallets";
import EditProfile from "Pages/EditProfile/EditProfile";
import MyQrCode from "Pages/MyQrCode";
import MyWallet from "Pages/MyWallet";
import Notifications from "Pages/Notifications";
import EAlbaniaPaymentDetails from "Pages/Payments/eAlbaniaPayments/eAlbaniaPaymentDetails";
import EAlbaniaPayments from "Pages/Payments/eAlbaniaPayments/eAlbaniaPayments";
import Payments from "Pages/Payments/Payments";
import SmartfinPaymentDetails from "Pages/Payments/smartfinPayments/smartfinPaymentDetails";
import SmartfinPayments from "Pages/Payments/smartfinPayments/smartfinPayments";
import Referral from "Pages/Referral";
import ResetPassword from "Pages/Settings/ResetPassword";
import Settings from "Pages/Settings/Settings";
import Splash from "Pages/Splash";
import PrivacyPolicy from "Pages/StaticContent/PrivacyPolicy";
import TermsConditions from "Pages/StaticContent/TermsConditions";
import WalletWindow from "Pages/WalletWindow";
import PublicRoute from "utils/PublicRoute";
import TokenHandler from "utils/TokenHandler";
import "./assets/css/media.css";
import "./assets/css/responsive.css";
import "./assets/css/style.css";
import Register from "./Pages/auth/Register";
import Dashboard from "./Pages/Dashboard/Dashboard";
import PrivateRoute from "./utils/PrivateRoute";

function App() {
  document.documentElement.classList.toggle("dark", localStorage.theme === "dark" || (!localStorage.theme && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches));

  return (
    <div className="App">
      <BrowserRouter>
        <ToastContextProvider>
          <AuthProvider>
            <TokenHandler />
            <div className="flex h-screen overflow-hidden">
              <Sidebar />
              <div className="flex-1 overflow-y-auto">
                <Routes>
                  <Route path="/" element={<Splash />} />
                  <Route path="/login-smartfin" element={<LoginFromSmartfin />} />
                  <Route path="/login-with-smartfin-callback" element={<LoginWithSmartfinCallback />} />
                  <Route element={<PublicRoute />}>
                    <Route path="/register" element={<Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register/otp" element={<RegisterOtp />} />
                    <Route path="/login/otp" element={<LoginOtp />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/otp" element={<OtpScreen />} />
                    <Route path="/terms-and-conditions" element={<TermsConditions />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  </Route>

                  <Route element={<PrivateRoute />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/notifications" element={<Notifications />} />
                    <Route path="/my-wallet" element={<MyWallet />} />
                    <Route path="/wallet-window" element={<WalletWindow />} />
                    <Route path="/transaction-details/:transactionId" element={<TransactionDetailsMobile />} />
                    <Route path="/mycode" element={<MyQrCode />} />
                    <Route path="/referral" element={<Referral />} />
                    <Route path="/edit-profile" element={<EditProfile />} />
                    {/* SETTINGS */}
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/settings/reset-password" element={<ResetPassword />} />
                    {/* ADD ROUTES */}
                    <Route path="/add-money" element={<AddMoney />} />
                    <Route path="/add-money/my-cards" element={<MyCards />} />
                    {/* TRANSFER ROUTES */}
                    <Route path="/transfer-money" element={<TransferMoney />} />
                    <Route path="/transfer-wallets" element={<TransferWallets />} />
                    <Route path="/transfer-username" element={<TransferUsername />} />
                    <Route path="/gift-cards" element={<GiftCards />} />
                    <Route path="/gift-cards/history" element={<GiftCardsHistory />} />
                    {/* PAYMENT ROUTES */}
                    <Route path="/payments" element={<Payments />} />
                    <Route path="/payments/ealbania" element={<EAlbaniaPayments />} />
                    <Route path="/payments/ealbania/pending-payment/:orderNumber" element={<EAlbaniaPaymentDetails />} />
                    <Route path="/payments/smartfin" element={<SmartfinPayments />} />
                    <Route path="/payments/smartfin/pending-payment/:orderNumber" element={<SmartfinPaymentDetails />} />
                  </Route>
                </Routes>
              </div>
            </div>
          </AuthProvider>
        </ToastContextProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
